"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _RevieveVirtualTryOnPDP = require("./RevieveVirtualTryOnPDP");
Object.keys(_RevieveVirtualTryOnPDP).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RevieveVirtualTryOnPDP[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _RevieveVirtualTryOnPDP[key];
    }
  });
});
